var _a;
export var CompanyNameColumn = {
    companyName: 'Company Name',
};
export var CompanyNameColumnValidation = (_a = {},
    _a[CompanyNameColumn.companyName] = { required: true },
    _a);
export var CompanyNameColumnValidationEntries = Object.entries(CompanyNameColumnValidation);
export var CompanyNameColumnCount = CompanyNameColumnValidationEntries.length;
export var CompanyNameColumns = CompanyNameColumnValidationEntries.map(function (_a) {
    var columnName = _a[0];
    return columnName;
});
export var CompanyNameColumnsString = CompanyNameColumns.join(',');
export var CompanyNameColumnTemplate = Object.fromEntries(CompanyNameColumnValidationEntries.map(function (_a) {
    var columnName = _a[0], columnConfig = _a[1];
    var values = [];
    if (columnConfig.required) {
        values.push('required');
    }
    return [columnName, values.length > 0 ? "(".concat(values.join(', '), ")") : ''];
}));
//# sourceMappingURL=companyNameColumns.js.map